export default __webpack_public_path__ + "static/media/font.59cd30ec.woff";